let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lVpti")).then(() => parcelRequire('j2fLh'));